import gql from 'graphql-tag'

export const CREATE_BARCODE_PRODUCT_CATEGORY = gql`
  mutation CreateBarcodeProductCategory($name: String!) {
    createBarcodeProductCategory(data: { name: $name }) {
      id
      name
    }
  }
`

export const UPDATE_BARCODE_PRODUCT_CATEGORY = gql`
  mutation UpdateBarcodeProductCategory($id: Int!, $name: String!) {
    updateBarcodeProductCategory(id: $id, data: { name: $name }) {
      id
      name
    }
  }
`

export const DELETE_BARCODE_PRODUCT_CATEGORY = gql`
  mutation DeleteBarcodeProductCategory($id: Int!) {
    deleteBarcodeProductCategory(id: $id) {
      id
    }
  }
`
